'use strict';

const inputDate = require('./inputDate');

const SELECTORS = {
    body: 'body',
    eventDateModal: '#eventDateModal'
}

function init() {
    $(SELECTORS.body).on('show.bs.modal', SELECTORS.eventDateModal, handleEventDateModalOpen);
    $(SELECTORS.body).on('inputDate:open', handleDatepickerOpen);

    $(function() {
        const urlParams = new URLSearchParams(window.location.search);
        const myParam = urlParams.get('eventDateError');

        if (myParam === 'true') {
            const modalTriggerElement = document.querySelector('.event-date-link');
            if (modalTriggerElement) {
                modalTriggerElement.click();
            }
        }
    });
}

const handleEventDateModalOpen = (event) => {
    let context = $(event.target);
    if ($(event.target).attr('id') === 'eventDateModal') {
        $(SELECTORS.body).trigger('inputDate:open', context);
    }
}

/**
 * The calendar renders inline and stays open, so "opening" it only means making
 * sure any date input injected into the modal body has its calendar initialised.
 * @returns {void}
 */
const handleDatepickerOpen = () => {
    inputDate.init();
}

module.exports = {
    init: init
}
